export const tipoAcionadoModel = {
  tipoAcionado: function () {
    return {
      ds_tipoacionado: '',
    }
  },
}


// WEBPACK FOOTER //
// ./src/views/TipoAcionado/_model/tipoAcionado.js